<script lang="ts" setup>
import LightArrowIcon from "@/components/icon/LightArrowIcon.vue";
import { Image, showLoadingToast, Loading, showToast } from "vant";
import { useI18n } from "vue-i18n";
import MediaSelectPopup from "../media/MediaSelectPopup.vue";
import { ref } from "vue";
import { MediaUploadFileItem } from "@/types/component";
import { computed } from "vue";
import { onMounted } from "vue";
import { featureExtraction } from "@/modules/api";
import { copyToClipboard } from "@/modules/common";
import i18n from "@/locales";

const { t } = useI18n();
const showImgUploadPopup = ref(false);

const selectedMedia = ref<MediaUploadFileItem | null>(null);

const description = ref("");

const onImgSelect = async ([img]: MediaUploadFileItem[]) => {
  selectedMedia.value = img;
  const toast = showLoadingToast({
    message: i18n.global.t("Message.parsingThePicture"),
  });
  try {
    const { data } = await featureExtraction(img.mediaId);
    description.value = data.prompt;
  } finally {
    toast.close();
  }

  toast.close();
};

const onClickCopy = () => {
  copyToClipboard(description.value);
  showToast({
    type: "success",
    message: i18n.global.t("Message.copySuccessful"),
  });
};

onMounted(() => {
  const toast = showLoadingToast({
    message: i18n.global.t("Message.parsingThePicture"),
  });
  toast.close();
});
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr_auto]">
    <!-- 顶部导航 -->
    <div class="navbar bg-base-100 h-top-nav">
      <!-- 左 -->
      <div class="navbar-start h-full">
        <button class="btn btn-ghost" @click="$router.back()">
          <light-arrow-icon />
        </button>
      </div>
      <!-- 中：占位 -->
      <div class="navbar-center">
        <span>{{ t(`trait.feature.extraction`) }}</span>
      </div>
      <!-- 右：占位 -->
      <div class="navbar-end"></div>
    </div>

    <div class="text-[#ABABAB] overflow-auto pb-5">
      <p class="text-base m-4">{{ t(`trait.image`) }}</p>

      <div
        :class="[
          'm-4 flex justify-center items-center min-h-[88px]',
          !selectedMedia && 'bg-[#2f2f2f]',
        ]"
      >
        <div class="flex flex-col items-center">
          <Image
            v-if="selectedMedia"
            :src="selectedMedia.url!"
            class="w-full h-full mb-5"
            fit="cover"
            crossorigin="anonymous"
          />
          <button
            class="border rounded-md px-10 py-1 text-xs flex items-center justify-center"
            @click="showImgUploadPopup = true"
          >
            <i class="iconify mingcute--pic-line mr-1"></i>
            {{ t(`trait.${selectedMedia ? "re" : ""}select`) }}
          </button>
        </div>
      </div>

      <div v-if="description">
        <p class="text-base m-4">{{ t(`trait.feature.description`) }}</p>

        <div class="m-4">
          <textarea
            v-model="description"
            class="resize-none w-full bg-transparent border border-[#2f2f2f] h-[137px] py-3 px-2.5 text-xs"
          />
        </div>
        <div class="text-center flex justify-center">
          <button
            class="rounded-lg px-10 py-2 text-xs text-center bg-[#E84B4B] text-white mt-6 flex items-center justify-center"
            @click="onClickCopy"
          >
            <i class="iconfont icon-copy mr-1"></i>
            {{ t(`trait.copy`) }}
          </button>
        </div>
      </div>
    </div>

    <media-select-popup
      v-model:show="showImgUploadPopup"
      :max-count="1"
      :multiple="false"
      :upload-type="7"
      enable-use-avatar
      enableCrop
      media-type="img"
      replace
      @on-media-selected="onImgSelect"
    />
  </div>
</template>
